{
  "cta": {
    "create-a-chart": "Créer un tableau"
  },
  "breadcrumb": {
    "dashboard": "Tableau de bord",
    "products": "Produits",
    "charts": "Tableaux de tailles",
    "restock-alerts": "Stock",
    "settings": "Paramètre",
    "setting": "Paramètre",
    "account": "Compte",
    "personal": "Personnel",
    "organization": "Organisation",
    "appearance": "Apparence",
    "themes": "Thèmes",
    "button": "Bouton",
    "font-family": "Famille de police",
    "uploads": "Téléchargements",
    "dimensions": "Dimensions",
    "notifications": "Notifications",
    "analytic": "Analyse",
    "analytics": "Analyse",
    "restock-settings": "Paramètres de réapprovisionnement",
    "inventory": "Stock",
    "plans": "Plans",
    "billing": "Facturation",
    "overview": "Aperçu",
    "plan-and-usage": "Plan et utilisation",
    "chart-views": "Vues des tableaux",
    "add-to-cart": "Ajouts au panier",
    "buy-now": "Achat immédiat",
    "size-recommendations": "Recommandations de taille",
    "stock-notifications": "Notifications de stock",
    "reports": "Rapports",
    "comparison": "Comparaison",
    "images": "Téléchargements",
    "sidekick": "Sidekick",
    "import": "Importation",
    "contact": "Contact",
    "help-articles": "Articles d'aide",
    "new": "Nouveau"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tableau à l’Excel",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Créez un tableau de données complètement personnalisable avec total contrôle sur chaque ligne, colonne et unité de mesure. Idéal pour les tailles complexes dans plusieurs régions.",
      "create-table-chart": "Créez un tableau de données",
      "create-from-product": "Créez un tableau de tailles à partir du produit",
      "start-from-template": "Démarrer à partir de modèle",
      "browse-templates": "Parcourir les modèles",
      "create-with-drag-drop": "Créer avec glisser et déposer",
      "creating": "Création en cours",
      "how-would-you-like-to-build-your-chart": "Comment aimeriez-vous<br /><span class=\"text-primary\">créer votre tableau?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Choisissez une méthode ci-dessous, ou dites-nous ce que vous vendez et nous mettrons en évidence le mieux adapté.",
      "fastest-setup-2-min": "Installation la plus rapide · ~2 min",
      "used-by-1000-merchants": "Utilisé par 1000+ commerçants",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Génère automatiquement un tableau de tailles correspondant en utilisant vos données des variantes Shopify. Pas de saisie manuelle — il lit votre produit et remplit le tableau pour vous",
      "garment-templates-ready-to-use": "Modèles de vêtements prêts à l'usage",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Choisissez parmi des modèles prêts à l'usage pour des sous-vêtements, des bas, des chaussures, des ceintures, des sacs et plus. Personnalisez n'importe quel champ après — idéal pour commencer en moins d'une minute.",
      "drag-drop-no-data-needed-upfront": "Glisser et déposer · pas de données nécessaires en avant",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Téléchargez n'importe quelle image de produit et annotez les mesures directement sur elle avec des pins de glissez-déposez. Idéal pour les chaussures, sacs, accessoires et équipement.",
      "excel-like": "comme Excel",
      "auto-generated": "Auto généré",
      "annotate-on-image": "Annotez sur l'image",
      "what-are-you-selling": "Que vendez-vous ?",
      "category-clothing-apparel": "Vêtements & habillement",
      "category-shoes": "Chaussures",
      "category-accessories": "Accessoires",
      "category-other": "Autre chose",
      "start-date": "Date de début",
      "end-date": "Date de fin"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Sélectionnez un produit pour créer ou lier un tableau de tailles pour ce produit.",
      "product-name": "Nom de produit",
      "best-selling": "Meilleures ventes",
      "most-selling": "Les plus vendus d'abord",
      "least-selling": "Ventes les plus faibles",
      "best-selling-unavailable": "Les données de ventes ne sont pas encore disponibles ; les produits sont affichés par dernière mise à jour.",
      "chart-attached": "Tableau associé",
      "shopify-status": "Statut de Shopify",
      "search-placeholder": "Rechercher tous les produits...",
      "vendors": "Fournisseurs",
      "tags": "Étiquettes",
      "statuses": "Statuts",
      "collections": "Collections",
      "types": "Types",
      "add-filter": "Ajouter un filtre",
      "categories": "Catégories",
      "search-and-filter-tooltip": "Rechercher et filtrer (F)",
      "import-selection": "Importer la sélection",
      "failed-import-measurements": "Échec de l'importation des mesures",
      "product-updated": "Produit mis à jour avec succès"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Créer, éditer, duplicer ou lier un tableau de tailles à un produit depuis ici.",
      "chart-name": "Nom du tableau de tailles",
      "chart-type": "Type de tableau",
      "linked-to": "Lié à",
      "last-updated": "Dernière mise à jour",
      "delete-x-charts": "Supprimer {{ x }} tableaux",
      "assigned-products": "Produits attribués",
      "failed-to-fetch-products-data": "Échec de la récupération des données des produits",
      "delete-chart": "Supprimer le tableau",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Voulez-vous vraiment supprimer les tableaux sélectionnés ? Tous les produits liés à ces tableaux seront désassignés.",
      "successfully-deleted-chart-s": "Les tableaux de tailles ont été supprimés avec succès!",
      "successfully-duplicated-chart": "Le tableau de tailles a été dupliqué avec succès!",
      "turn-this-into-a-conversion-chart": "Transformez-le en guide de conversion",
      "upgradable-tooltip": "Ce tableau ressemble à un guide des tailles structuré et peut être converti.",
      "convert-to-size-chart": "Convertir en guide des tailles",
      "convertibility-failed": "Impossible de vérifier quels tableaux peuvent être convertis.",
      "convert": {
        "table-chart-info-callout": "Ce tableau de tailles peut être converti en guide des tailles intelligent",
        "table-chart-info-callout-message": "La conversion associe votre tableau à des dimensions de votre bibliothèque, ce qui débloque un guide de mesure visuel et les infos du modèle — impossible à afficher dans un simple tableau.",
        "successfully-converted": "Converti en guide des tailles avec succès !",
        "detected-sizes": "Tailles détectées",
        "at-least-two-sizes-are-needed": "Au moins deux tailles sont nécessaires pour convertir ce guide.",
        "unnamed-row": "Ligne sans nom",
        "ignore-this-row": "Ignorer cette ligne",
        "this-dimension-is-already-mapped": "Cette dimension est déjà associée à une autre ligne.",
        "map-at-least-one-row": "Associez au moins une ligne à une dimension.",
        "finish-your-measurement-guide": "Terminez votre guide de mesure",
        "measurement-points-without-values": "Points de mesure sans valeur ({{ x }})",
        "fill-them-in-after-converting": "Votre image sélectionnée les affiche, mais votre tableau n'avait pas ces lignes. Renseignez leurs valeurs après la conversion.",
        "measurements-without-points": "Mesures sans point sur votre image ({{ x }})",
        "no-image-selected-yet": "Aucune image sélectionnée pour l'instant",
        "upload-an-image-then-drag-points": "Importez une image, puis glissez-déposez les points de mesure dessus.",
        "your-image-has-no-measurement-points": "Votre image sélectionnée n'a pas encore de points de mesure",
        "drag-measurement-points-onto-the-image": "Glissez-déposez leurs points de mesure sur l'image pour que les clients voient où mesurer.",
        "plus-x-more": "+{{ x }} de plus",
        "satisfied-button": "Ça me convient — en faire mon guide actif",
        "satisfied-explanation": "Votre tableau des tailles sera dépublié, ce guide sera publié, et ses produits assignés seront transférés.",
        "satisfied-success": "Ce guide est maintenant actif !",
        "step-x-of-y": "Étape {{ x }} sur {{ y }}",
        "choose-product-type": "Choisissez le type de produit",
        "well-match-your-table-to-a-visual": "Nous associerons votre tableau au bon visuel produit.",
        "save-settings": "Enregistrer les paramètres",
        "review-table-mapping": "Vérifiez l'association du tableau",
        "confirm-the-rows-to-convert": "Confirmez les lignes à convertir.",
        "existing-table": "Tableau existant",
        "sizes": "Tailles",
        "row": "Ligne",
        "column": "Colonne",
        "x-rows-need-review": "{{ x }} lignes à vérifier",
        "couldnt-match-this-row": "Nous n'avons pas pu associer cette mesure automatiquement",
        "change-match": "Modifier l'association",
        "view-values": "Voir les valeurs",
        "hide-values": "Masquer les valeurs",
        "matched-automatically": "Associées automatiquement",
        "edit-matches": "Modifier les associations",
        "create-preview": "Créer l'aperçu",
        "preview-ready": "Aperçu prêt",
        "open-it-to-finish-the-missing-values": "Ouvrez-le pour compléter les valeurs manquantes.",
        "converted": "Converti",
        "open-preview": "Ouvrir l'aperçu",
        "you-can-add-them-in-the-preview": "Vous pourrez les ajouter dans l'aperçu."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Collecter des emails et envoyer des notifications automatiques de restockage. Configurez les notifications",
      "here": "ici",
      "successfully-export-inventory-data": "Les données de stock ont été exportées avec succès!",
      "active-your-store-inventory-notification-feature": "Activez la fonction de notifications d'inventaire",
      "in-order-to-receive-users-subscribed-for-your-products": "afin de recevoir des notifications pour les clients abonnés à vos produits.",
      "your-subscribers-have-been-delegeted-to-your": "Vos abonnés ont été délégués à votre"
    },
    "setting": {
      "storefront-popup-preview": "Aperçu de la fenêtre contextuelle de la boutique",
      "add-to-cart": "Ajouter au panier",
      "buy-now": "Acheter maintenant",
      "sans-serif": "Sans serif",
      "serif": "Serif",
      "email-body-is-required": "Le corps de l'e-mail est obligatoire",
      "list": "Liste",
      "category-image": "Image de catégorie",
      "pay-over-usage-cost": "Payer le coût de dépassement",
      "over-usage-count": "Nombre de dépassements",
      "over-usage-cost": "Coût de dépassement",
      "x-usages": "{{ x }} utilisations",
      "failed-to-pay-over-usage-cost": "Échec du paiement du coût de dépassement",
      "manage-your-personal-information-and-account-perferences": "Gérez vos informations personnelles et les préférences de votre compte.",
      "manage-your-organization-contact-information-and-address": "Gérez les coordonnées et l'adresse de votre organisation.",
      "manage-your-billing-overview": "Consultez vos informations de facturation, votre plan et vos moyens de paiement.",
      "manage-your-plan-and-usage": "Consultez votre plan actuel et vos limites d'utilisation.",
      "manage-your-measurement-dimensions": "Gérez vos dimensions de mesure utilisées dans vos tableaux de tailles.",
      "dimension-translations": "Traductions de la boutique",
      "dimension-translations-description": "Saisissez le libellé que les clients doivent voir pour chaque langue prise en charge dans la boutique. Laissez vide pour utiliser le nom par défaut.",
      "default-dimension-name": "Nom par défaut de la dimension",
      "dimension-name-description": "Utilisé dans tout le tableau de bord et comme libellé de secours dans la boutique lorsqu'aucune traduction n'est fournie.",
      "storefront-label": "Libellé de la boutique",
      "naming": "Nommage",
      "affecting-data": "Données affectées",
      "first-name-is-required": "Le prénom est requis",
      "last-name-is-required": "Le nom est requis",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Vous êtes abonné à nos dernières nouvelles, offres exclusives et mises à jour.",
      "contact-information": "Informations de contact",
      "contact-name": "Nom de contact",
      "contact-name-is-required": "Le nom de contact est requis!",
      "contact-email": "Email de contact",
      "contact-email-is-required": "L'email de contact est requis!",
      "contact-email-is-invalid": "L'email de contact est invalide!",
      "company-organization-name": "Nom de l'entreprise/organisation",
      "company-organization-name-is-required": "Le nom de l'entreprise/organisation est requis!",
      "street-address": "Adresse de la rue",
      "street-address-is-required": "L'adresse de la rue est requise!",
      "street-address-2": "Adresse de la rue 2",
      "city": "Ville",
      "city-is-required": "La ville est requise!",
      "state-province-region": "Région d'État/province/région",
      "state-province-region-is-required": "La région d'État/province/région est requise!",
      "country": "Pays",
      "country-is-required": "Le pays est requis!",
      "postal-zip-code": "Code postal/ZIP",
      "postal-zip-code-is-required": "Le code postal/ZIP est requis!",
      "themes": "Thèmes",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Personnalise l'aspect de votre application ! Choisissez une couleur qui reflète le mieux votre marque.",
      "sunset-ember": "Embrun de soleil",
      "classic-noir": "Noir classique",
      "system-background-colour": "Couleur d'arrière-plan du système",
      "customise-your-button": "Personnalisez votre bouton",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Personnalisez le texte, la couleur et le style de votre bouton pour correspondre à votre marque.",
      "what-should-the-button-say": "Quel texte devrait avoir le bouton?",
      "label-button-is-required": "Le texte du bouton est requis!",
      "text-colour": "Couleur du texte",
      "text-colour-is-required": "La couleur du texte est requise!",
      "please-input-valid-hex-color-code": "Veuillez entrer un code couleur en hexadécimal valide",
      "background-color": "Couleur d'arrière-plan",
      "background-colour-is-required": "La couleur d'arrière-plan est requise!",
      "font-size-in-px": "Taille de police en pixels",
      "font-size-in-px-is-required": "La taille de police en pixels est requise!",
      "border-radius": "Rayon du bord",
      "border-radius-is-required": "Le rayon du bord est requis!",
      "successfully-updated-button-style": "Le style du bouton a été mis à jour avec succès!",
      "font-family": "Famille de police",
      "customise-your-font": "Personnalisez votre police",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Adaptez le look et l'aspect de votre boutique en mettant à jour la police dans vos tableaux de tailles.",
      "select-a-font-from-the-list-bellow": "Sélectionnez une police dans la liste ci-dessous.",
      "search-font": "Rechercher une police...",
      "fetching-fonts": "Récupération des polices...",
      "showing-x-fonts": "Affichage de {{ x }} polices",
      "sort-by-x": "Trier par {{ x }}",
      "most-popular": "Le plus populaire",
      "here-how-it-will-look-on-your-shop": "C'est comment cela apparaîtra sur votre boutique",
      "it-ll-updated-across-all-your-chart-displays": "Il sera mis à jour dans tous vos tableaux de tailles.",
      "update-font-across-all-size-charts": "Mettre à jour la police dans tous vos tableaux de tailles",
      "choose-a-font-to-match-your-store-style": "Sélectionnez une police pour correspondre au style de votre boutique",
      "apply-font": "Appliquer la police",
      "font-applied-successfully": "La police a été appliquée avec succès!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Gérer et supprimer vos images téléchargées. La suppression d'un fichier est permanente et irréversible.",
      "do-you-want-to-delete-image": "Voulez-vous supprimer l'image?",
      "image-deleted-successfully": "L'image a été supprimée avec succès",
      "chart-list": "Liste des tableaux de tailles",
      "delete-x-dimensions": "Supprimer {{x}} dimensions",
      "view-affecting-data": "Voir les données impactées",
      "no-data-will-be-affected": "Aucune donnée ne sera affectée.",
      "do-you-want-to-delete-selected-dimensions": "Voulez-vous supprimer les dimensions sélectionnées ?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Les ensembles d'annotations et les tableaux de tailles utilisant ces dimensions auront leurs annotations et données supprimées.",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Les ensembles d'annotations et les tableen de tailles utilisant ces dimensions auront leur nom modifié.",
      "delete-dimension": "Supprimer la dimension",
      "successfully-deleted-dimension": "La dimension a été supprimée avec succès!",
      "successfully-update-dimension": "La dimension a été mise à jour avec succès!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Configurer comment les notifications de restock fonctionnent pour vos clients",
      "activate-back-in-stock-notifications": "Activer les notifications de restock",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Permettre aux acheteurs de s'inscrire pour recevoir des alertes lorsqu'une taille ou un produit est épuisé. Les notifications seront envoyées automatiquement une fois que le stock est disponible.",
      "notification-channels": "Canaux de notification",
      "third-party-service": "Service tiers",
      "sms": "SMS",
      "coming-soon": "Prochainement",
      "signup-experience-design": "Conception de l'expérience d'inscription",
      "form-display": "Affichage du formulaire",
      "modal-popup": "Popup modale",
      "email-template-customisation": "Personnalisation du modèle d'email",
      "subject-line": "Sujet",
      "subject-line-is-required": "Le sujet est requis",
      "your-size-is-back-in-stock": "Votre taille est de nouveau en stock 🎉",
      "email-body": "Corps de l'email",
      "inventory-threshold-setting": "Paramétrage du seuil d'inventaire",
      "notify-shoppers-when-inventory-reaches-at-least": "Notifiez les clients lorsqu'il atteint au moins",
      "threshold-is-required": "Le seuil est requis",
      "threshold-must-be-greater-than-0": "Le seuil doit être supérieur à 0",
      "units": "unités",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Fixez le niveau d'inventaire minimal requis pour déclencher les notifications",
      "choose-a-service": "Choisir un service",
      "signing-out": "Se désconnecter",
      "signout-of": "Désconnexion de",
      "authenticate": "Authentifier",
      "save-settings": "Sauvegarder les paramètres",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Bonjour {{first_name}}, votre {{product_name}} ({{size_variant}}) est maintenant en stock. Obtenez-le avant qu'il ne soit épuisé !",
      "successfully-updated-notification-back-in-stock": "La notification de restock a été mise à jour avec succès.",
      "preferred-language": "Langue préférée",
      "successfully-updated-your-profile": "Votre profil a été mis à jour avec succès",
      "successfully-updated-mailing-subscription-status": "Le statut de votre abonnement à la liste de diffusion a été mis à jour!",
      "upgrade-plan": "Mettre à niveau le plan",
      "overview": "Aperçu",
      "billing-cycle": "Cycle de facturation",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Le cycle de facturation reprend à minuit le {{ x }} et la prochaine facturation est le {{ y }}",
      "billing-information": "Information de facturation",
      "update-billing": "Mettre à jour la facturation",
      "monthly-total": "Total mensuel",
      "free-trial-x-days-left": "Essai gratuit - {{ x }} jours restants",
      "cancel-plan": "Annuler le plan",
      "change-plan": "Changer de plan",
      "plan-and-usage": "Plan et utilisation",
      "tier-offers-in-use": "Offres de niveau en utilisation",
      "failed-to-cancel-plan": "Échec de l'annulation du plan",
      "total-usage": "Utilisation totale",
      "current-usage-summary": "Résumé de l'utilisation actuelle",
      "published-charts": "Tableaux publiés",
      "limit-reached": "limite atteinte",
      "plan-details": "Détails du plan",
      "current-plan": "Plan actuel",
      "select-a-reason": "Sélectionner une raison",
      "please-provide-your-reason": "Veuillez fournir votre raison",
      "chart-preferences": "Préférences du tableau",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Passer la sélection des dimensions lors de la création d'un nouveau tableau à partir d'un modèle",
      "border-color": "Couleur du bord",
      "border-color-is-required": "La couleur du bord est requise!",
      "list-of-charts-using-this-image": "Liste des tableaux utilisant cette image",
      "successfully-update-your-profile": "Votre profil a été mis à jour avec succès"
    },
    "analytic": {
      "failed-to-load-statistics": "Échec du chargement des statistiques",
      "total-chart-views": "Vues des tableaux",
      "total-add-to-cart": "Ajouts au panier",
      "traffic-by-location": "Trafic par localisation",
      "desktop": "Ordinateur",
      "mobile": "Mobile",
      "size-recommendations": {
        "failed-to-load": "Échec du chargement des analyses de recommandations de taille",
        "total-suggestions-title": "Suggestions",
        "conversion-title": "Conversion",
        "customers-proceeded": "Clients ayant suivi la suggestion",
        "of-x-suggestions": "sur {{count}} suggestions",
        "most-suggested-title": "Produit et variante les plus suggérés",
        "suggestions-count": "{{count}} suggestions",
        "most-common-profile-title": "Profil le plus courant",
        "average-profile-title": "Profil moyen",
        "gender": "Genre",
        "age-group": "Tranche d'âge",
        "height": "Taille",
        "weight": "Poids",
        "size-recommended": "Taille recommandée",
        "graph-suggestions": "Suggestions",
        "graph-proceed": "Acceptées",
        "source-all": "Tous",
        "source-chart": "Tableau de tailles",
        "source-table-chart": "Tableau personnalisé"
      },
      "chart-views": {
        "failed-to-load": "Échec du chargement des vues des tableaux",
        "device-types": "Types d'appareil",
        "most-viewed-chart": "Tableau le plus consulté",
        "most-viewed-product": "Produit le plus consulté",
        "views-count": "{{ count }} vues",
        "view-at": "Consulté le",
        "location": "Localisation",
        "graph-label": "Vues"
      },
      "add-to-cart": {
        "failed-to-load": "Échec du chargement des analyses d'ajout au panier",
        "estimated-revenue": "Valeur estimée influencée",
        "conversion-title": "Conversion vue du tableau → ajout au panier",
        "most": "Plus ajoutés au panier",
        "adds-count": "{{count}} ajouts au panier",
        "added-at": "Ajouté le",
        "graph-label": "Ajouts au panier",
        "views-dataset-label": "Vues",
        "add-to-cart-dataset-label": "Ajout au panier"
      },
      "stock-notifications": {
        "failed-to-load": "Échec du chargement des analyses de notifications de stock",
        "failed-to-load-table": "Échec du chargement du tableau des notifications de stock",
        "total-subscriptions": "Abonnements",
        "total-notifications-sent": "Notifications envoyées",
        "delivery-rate": "Taux de livraison",
        "opened-of-notified": "{{ opened }} ouvertes / {{ notified }} notifiées",
        "most-subscribed": "Les plus abonnés",
        "subscriptions-count": "{{ count }} abonnements",
        "latest-subscribed": "Dernier abonné",
        "subscribed-at": "Abonné le : {{ date }}",
        "longest-waiting": "Plus longue attente de réapprovisionnement",
        "waiting-days": "Attente : {{ days }} jours",
        "waiting-since": "(depuis {{ date }})",
        "subscriptions": "Abonnements",
        "notifications-sent": "Notifications envoyées",
        "opened": "Ouvertes",
        "at": "Le",
        "graph-label": "Abonnements"
      },
      "paid-gate": {
        "unlock-message": "Débloquez les analyses avancées pour voir toutes les données et prendre de meilleures décisions.",
        "upgrade": "Mettre à niveau",
        "failed-to-fetch-plans": "Échec du chargement des forfaits"
      },
      "buy-now": {
        "failed-to-load": "Échec du chargement des statistiques d'achat immédiat",
        "total": "Achats immédiats",
        "estimated-revenue": "Valeur estimée influencée",
        "conversion-title": "Conversion vue du tableau → achat immédiat",
        "most": "Produit le plus acheté en achat immédiat",
        "buys-count": "{{count}} achats immédiats",
        "graph-label": "Achats immédiats",
        "views-dataset-label": "Vues",
        "buy-now-dataset-label": "Achat immédiat",
        "clicked-at": "Cliqué le"
      },
      "overview": {
        "funnel-title": "Ce que sont devenues les vues des tableaux",
        "no-views-title": "Aucune vue de tableau sur cette période",
        "no-views-hint": "Les tableaux de tailles apparaissent sur les pages produits une fois publiés et associés à des produits.",
        "chart-views-caption": "Acheteurs ayant ouvert un tableau de tailles",
        "baseline-caption": "Tout ce qui suit est rapporté à ces vues",
        "of-views": "sur {{ count }} vues",
        "not-in-funnel": "Hors du parcours des tableaux"
      },
      "preview": {
        "title": "Pas encore de données — aperçu",
        "message": "Les chiffres ci-dessous sont des données d’exemple montrant à quoi ressemblera cette page une fois que les acheteurs utiliseront vos tableaux de tailles."
      }
    },
    "plans": {
      "popular-plan": "Plan populaire",
      "try-now": "Essayer maintenant",
      "activated": "Activé",
      "contact-sales": "Contactez les ventes",
      "try-free-for-1-month": "Essayer gratuitement pour 1 mois",
      "activate": "Activer",
      "what-included": "Ce qui est inclus ?",
      "choose-the-plan-that-fits-your-business-needs": "Choisissez le plan qui correspond à vos besoins",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Que vous soyez juste au début ou que vous cherchiez une solution de taille robuste, nous avons un plan qui vous convient.",
      "monthly": "Mensuel",
      "annually": "Annuel",
      "compare-plan-features": "Comparer les fonctionnalités du plan",
      "compare-all-plan-features": "Comparer toutes les fonctionnalités des plans",
      "feature-usages": "Utilisations",
      "feature-analytics": "Analyses",
      "feature-support": "Support",
      "feature-integration": "Intégration",
      "feature-branding": "Image de marque",
      "feature-api-access": "Accès API",
      "feature-stock-notifications": "Notifications de stock",
      "feature-published-conversion-charts": "Guides de conversion publiés",
      "feature-advanced-variant-mapping": "Mappage avancé des variantes",
      "failed-to-fetch-plans": "Échec de la récupération des plans",
      "failed-to-activate-plan": "Échec de l'activation du plan",
      "contact": {
        "title": "Contactez les ventes",
        "subtitle": "Parlez-nous de votre boutique et de vos besoins. Notre équipe vous répondra par e-mail.",
        "message-placeholder": "Comment pouvons-nous aider votre entreprise ?",
        "send": "Envoyer le message",
        "success": "Merci ! Votre message a été envoyé. Notre équipe vous contactera rapidement.",
        "first-name-required": "Le prénom est requis",
        "last-name-required": "Le nom est requis",
        "email-required": "L'e-mail est requis",
        "email-invalid": "L'e-mail n'est pas valide",
        "message-required": "Le message est requis"
      },
      "invite": {
        "title": "Finalisez votre abonnement",
        "your-plan": "Votre forfait",
        "order-summary": "Récapitulatif de la commande",
        "billed-every-30-days": "Facturé tous les 30 jours",
        "billed-yearly": "Facturé chaque année",
        "free-trial": "Essai gratuit de {{days}} jours",
        "due-today": "À payer aujourd'hui",
        "then-every-30-days": "Puis {{price}} USD tous les 30 jours",
        "then-yearly": "Puis {{price}} USD par an",
        "continue": "Continuer vers l'approbation",
        "shopify-note": "Facturation via Shopify. Vous approuverez le paiement à l'écran suivant.",
        "switching-note": "Ce forfait remplace votre forfait actuel dès votre approbation. Shopify applique tout crédit pour le temps restant.",
        "already-on-plan": "Vous avez déjà ce forfait",
        "unavailable-title": "Cette invitation n'est plus disponible",
        "unavailable-body": "Le lien a peut-être expiré. Contactez la personne qui vous l'a envoyé ou consultez les forfaits ouverts à toutes les boutiques.",
        "see-plans": "Voir les forfaits",
        "failed-title": "Impossible de charger ce forfait",
        "failed-body": "Vérifiez votre connexion et rechargez la page."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Veuillez vous connecter",
        "email-is-required": "L’adresse e-mail est requise",
        "invalid-email-address": "Adresse e-mail invalide",
        "password-is-required": "Le mot de passe est requis",
        "sign-in": "Se connecter",
        "reset-password": "Réinitialiser le mot de passe",
        "generic-error": "Une erreur est survenue lors du traitement ! Veuillez réessayer plus tard."
      }
    },
    "admin": {
      "reports": {
        "title": "Rapports",
        "chart-views": {
          "title": "Consultations du tableau de tailles",
          "description": "Voyez combien de fois les acheteurs ont ouvert le tableau de tailles, globalement pour toutes les boutiques.",
          "failed-to-load": "Échec du chargement du rapport des vues des tableaux",
          "total-views": "Vues des tableaux",
          "most-viewed-chart": "Tableau le plus consulté",
          "most-viewed-product": "Produit le plus consulté",
          "views-count": "{{ count }} vues",
          "traffic-by-location": "Trafic par localisation",
          "device-types": "Types d'appareil",
          "desktop": "Ordinateur",
          "mobile": "Mobile",
          "top-stores": "Meilleures boutiques",
          "no-top-stores": "Aucune donnée de boutique pour le moment",
          "graph-label": "Vues",
          "view-at": "Consulté le",
          "location": "Localisation"
        },
        "add-to-cart": {
          "title": "Ajouts au panier",
          "description": "Voyez comment le tableau de tailles influence les ajouts au panier, globalement pour toutes les boutiques.",
          "failed-to-load": "Échec du chargement du rapport des ajouts au panier",
          "total-add-to-cart": "Ajouts au panier",
          "conversion-title": "Conversion vue du tableau → ajout au panier",
          "most": "Plus ajoutés au panier",
          "adds-count": "{{ count }} ajouts au panier",
          "top-stores": "Meilleures boutiques",
          "no-top-stores": "Aucune donnée de boutique pour le moment",
          "graph-label": "Ajouts au panier",
          "views-dataset-label": "Vues",
          "add-to-cart-dataset-label": "Ajout au panier",
          "added-at": "Ajouté le"
        },
        "buy-now": {
          "title": "Achats immédiats",
          "description": "Voyez comment le tableau de tailles influence les achats immédiats, globalement pour toutes les boutiques.",
          "failed-to-load": "Échec du chargement du rapport des achats immédiats",
          "total-buy-now": "Achats immédiats",
          "conversion-title": "Conversion vue du tableau → achat immédiat",
          "most": "Produit le plus acheté en achat immédiat",
          "buys-count": "{{ count }} achats immédiats",
          "top-stores": "Meilleures boutiques",
          "no-top-stores": "Aucune donnée de boutique pour le moment",
          "graph-label": "Achats immédiats",
          "views-dataset-label": "Vues",
          "buy-now-dataset-label": "Achat immédiat",
          "clicked-at": "Cliqué le"
        },
        "conversion-funnel": {
          "title": "Conversion des tableaux",
          "description": "Voyez où les marchands abandonnent la conversion d'un tableau en guide des tailles, globalement pour toutes les boutiques.",
          "failed-to-load": "Échec du chargement du rapport de conversion des tableaux",
          "total-runs": "Conversions démarrées",
          "runs-breakdown": "{{ converted }} converties · {{ handedOver }} transférées",
          "conversion-title": "Démarrées → Converties",
          "handover-rate": "{{ rate }} % ont ensuite transféré leurs produits",
          "handover-gap-title": "Converties, sans transfert",
          "of-converted-runs": "des tentatives converties",
          "handover-gap-description": "Un transfert peut avoir lieu plusieurs jours après : certaines de ces tentatives sont encore en attente plutôt qu'abandonnées.",
          "funnel-title": "Entonnoir de conversion",
          "funnel-note": "L'étape de transfert dédiée n'est plus déclenchée : la bannière est désormais le moyen par lequel les transferts sont finalisés, lisez donc son nombre comme le total des transferts plutôt que comme une conversion d'étape.",
          "no-funnel": "Aucune tentative de conversion sur cette période",
          "drop-off": "abandon",
          "runs-dataset-label": "Tentatives",
          "drop-offs-title": "Où s'arrêtent les tentatives",
          "drop-offs-description": "La dernière action de chaque tentative. Celles qui se terminent par un transfert terminé — désormais enregistré via la bannière — se sont bien déroulées.",
          "no-drop-offs": "Aucune tentative de conversion sur cette période",
          "dwell-title": "Temps avant de partir",
          "dwell-description": "Enregistré uniquement lorsqu'un marchand abandonne une étape, ainsi que le temps passé à lire le récapitulatif avant de confirmer.",
          "no-dwell": "Aucune donnée de durée sur cette période",
          "step": "Étape",
          "samples": "Échantillons",
          "median": "Médiane",
          "p90": "P90",
          "top-stores": "Meilleures boutiques",
          "no-top-stores": "Aucune donnée de boutique pour le moment",
          "graph-label": "Conversions démarrées",
          "started-at": "Démarrée le",
          "duration": "Durée",
          "last-step": "Dernière étape",
          "outcome": "Résultat",
          "steps": {
            "entry": "Ouverture",
            "category": "Catégorie",
            "mapping": "Correspondances",
            "summary": "Récapitulatif",
            "convert": "Conversion",
            "handover": "Transfert",
            "banner": "Bannière"
          },
          "actions": {
            "viewed": "vue",
            "completed": "terminée",
            "skipped": "ignorée",
            "back": "retour",
            "abandoned": "abandonnée",
            "failed": "échouée",
            "customize_clicked": "personnalisation ouverte",
            "dismissed": "fermée"
          },
          "outcomes": {
            "handed-over": "Transférée",
            "converted": "Convertie seulement",
            "failed": "Échouée",
            "abandoned": "Abandonnée",
            "in-progress": "En cours"
          }
        }
      },
      "delete-category": "Supprimer la catégorie",
      "do-you-want-to-delete-selected-categories": "Voulez-vous supprimer les catégories sélectionnées ?",
      "global-categories-are-shared-by-every-store": "Les catégories globales sont partagées par toutes les boutiques — en supprimer une affecte toutes les boutiques. Cette action est irréversible.",
      "successfully-deleted-category": "Catégorie supprimée avec succès",
      "average-cost-per-recommendation": "Coût moyen par recommandation",
      "failed-to-load-recommendations-average-cost": "Échec du chargement du coût moyen des recommandations",
      "most-expensive-extract": "Extraction la plus coûteuse",
      "most-expensive-recommendation": "Recommandation la plus coûteuse",
      "total-recommendation-cost": "Coût total des recommandations",
      "total-size-recommendation": "Recommandations de taille",
      "total-sheet-extract": "Extractions de feuille",
      "new-category": "Nouvelle catégorie",
      "category-created-unlisted-hint": "La catégorie est créée non répertoriée. Ajoutez une image et des mesures avant de la publier sur les boutiques.",
      "category-created-successfully": "Catégorie créée avec succès !",
      "category-search-placeholder": "Nom de l'image, nom de la boutique...",
      "dimension-search-placeholder": "Nom de la dimension, nom de la boutique...",
      "category-not-found": "Catégorie introuvable",
      "sub-categories-variants": "Sous-catégories/ variantes :",
      "add-sub-category-variant": "Ajouter une sous-catégorie/ variante :",
      "from-existing": "Depuis l'existant",
      "create-a-new": "Créer une nouvelle",
      "sub-category-removed": "Sous-catégorie supprimée !",
      "remove-sub-category": "Supprimer la sous-catégorie",
      "remove-sub-category-confirm": "Supprimer {{ x }} de cette catégorie ? Elle reste disponible en tant que catégorie de premier niveau.",
      "update-category": "Modifier la catégorie",
      "published-category-hint": "Une catégorie publiée est visible par toutes les boutiques. Les catégories non répertoriées restent masquées.",
      "category-updated-successfully": "Catégorie mise à jour avec succès !",
      "uninstalled": "Désinstallé",
      "inactive": "Inactif",
      "install-at": "Installé le",
      "total-chart-views": "Vues des tableaux",
      "chart-view-at": "Vu le",
      "store-id": "ID boutique",
      "successfully-deleted-clients": "Clients supprimés avec succès !",
      "session-replay": "Rejeu de session",
      "watch-on-amplitude": "Voir sur Amplitude",
      "shopify-app": "Application Shopify",
      "shops-online-store": "Boutique en ligne",
      "no-more-events-to-load": "Plus d'événements à charger !",
      "failed-to-fetch-events": "Échec de la récupération des événements !",
      "info": "Info",
      "store-info": "Infos boutique",
      "days-ago": "il y a {{ x }} jours",
      "contact-email": "E-mail de contact",
      "store-url": "URL de la boutique",
      "activities": "Activités",
      "insights": "Analyses",
      "subscriptions": "Abonnements",
      "failed-to-fetch-client-info": "Échec de la récupération des informations du client !",
      "failed-to-load-add-to-cart-analytics": "Échec du chargement des analyses d'ajout au panier",
      "failed-to-load-buy-now-analytics": "Échec du chargement des analyses d'achat immédiat",
      "failed-to-load-chart-views": "Échec du chargement des vues de tableaux",
      "failed-to-load-size-recommendations-analytics": "Échec du chargement des analyses de recommandation de taille",
      "failed-to-load-stock-notifications-analytics": "Échec du chargement des analyses de notifications de stock",
      "failed-to-load-stock-notifications-table": "Échec du chargement du tableau des notifications de stock",
      "chart-views": "Vues de tableaux",
      "add-to-cart": "Ajout au panier",
      "buy-now": "Achat immédiat",
      "size-recommendations": "Recommandations de taille",
      "stock-notifications": "Notifications de stock",
      "change-details": "Modifier les détails",
      "plan-subscription-details": "Détails de l'abonnement au forfait",
      "ai-size-recommendation-limit": "Limite de recommandation de taille IA",
      "ai-size-recommendation-limit-required": "La limite de recommandation de taille IA est requise !",
      "minimum-limit-is-0": "La limite minimale est 0 !",
      "unlimited": "Illimité",
      "chart-limit-drafts-hint": "Seuls les tableaux publiés comptent. Les brouillons sont illimités.",
      "chart-limit-required": "La limite de tableaux est obligatoire !",
      "chart-limit-whole-number": "La limite doit être un nombre entier !",
      "stock-notification-limit": "Limite de notification de stock",
      "stock-notification-limit-required": "La limite de notification de stock est requise !",
      "published-size-chart-limit": "Limite de tableaux de tailles publiés",
      "published-table-chart-limit": "Limite de tableaux de données publiés",
      "analytic": "Analytique",
      "full-suite": "Suite complète",
      "select-a-subscription-plan": "Sélectionner un forfait d'abonnement",
      "failed-to-fetch-plans": "Échec de la récupération des forfaits !",
      "new-plan": "Nouveau forfait",
      "failed-to-assign-plan-subscription-to-client": "Échec de l'attribution du forfait au client !",
      "ai-size-recommendation": "Recommandation de taille IA",
      "stock-notification": "Notification de stock",
      "published-size-charts": "Tableaux de tailles publiés",
      "published-table-charts": "Tableaux de données publiés",
      "analytic-access": "Accès analytique",
      "activated-at": "Activé le",
      "usages": "Utilisations",
      "failed-to-fetch-client-plan-subscription": "Échec de la récupération de l'abonnement du client !",
      "advanced-variant-mapping": "Correspondance avancée des variantes",
      "advanced-variant-mapping-description": "Les guides utilisent leurs propres tailles sur chaque produit assigné, et Ajouter au panier choisit la variante de produit correspondante. Désactivée, les tailles d'un guide doivent correspondre exactement aux noms des variantes de chaque produit.",
      "advanced-variant-mapping-counts": "{{ total }} guides · {{ x }} en correspondance avancée des variantes",
      "advanced-variant-mapping-drift": "{{ x }} guides ne correspondent pas à ce réglage.",
      "advanced-variant-mapping-repair": "Réparer",
      "turn-on-advanced-variant-mapping": "Activer la correspondance avancée des variantes ?",
      "turn-off-advanced-variant-mapping": "Désactiver la correspondance avancée des variantes ?",
      "advanced-variant-mapping-on-body": "Les {{ x }} guides de ce client basculent immédiatement, et les nouveaux guides l'utiliseront aussi. Les mesures ne sont pas modifiées, et vous pouvez la désactiver à nouveau.",
      "advanced-variant-mapping-off-body": "Les {{ x }} guides de ce client reviennent à la correspondance exacte des noms de variantes. Les guides dont les tailles ont été renommées pendant l'activation (par ex. « Blue / S » en « S ») afficheront des mesures vides sur les produits dont les noms de variantes ne correspondent plus.",
      "turn-on": "Activer",
      "turn-off": "Désactiver",
      "failed-to-fetch-advanced-variant-mapping": "Impossible de récupérer la correspondance avancée des variantes !",
      "failed-to-update-advanced-variant-mapping": "Impossible de mettre à jour la correspondance avancée des variantes !",
      "plan-used-as-free-trial": "Forfait utilisé comme essai gratuit pour les nouveaux clients",
      "x-usages": "{{ x }} utilisations",
      "successfully-updated-configuration-value": "Valeur de configuration mise à jour avec succès",
      "only-authorized-personnel-hint": "Seul le personnel autorisé peut accéder et modifier la configuration globale de l'application !",
      "password-is-required": "Le mot de passe est requis",
      "authorize": "Autoriser",
      "1-month": "1 mois",
      "3-months": "3 mois",
      "6-months": "6 mois",
      "1-year": "1 an",
      "failed-to-load-costs": "Échec du chargement des coûts",
      "failed-to-load-total-recommendations": "Échec du chargement du total des recommandations",
      "archived": "Archivé",
      "billing-interval": "Intervalle de facturation",
      "plan-information": "Informations sur le forfait",
      "name-is-required": "Le nom est requis !",
      "features": "Fonctionnalités",
      "stock-notification-recommendation-limit": "Limite de recommandation de notification de stock",
      "popular": "Populaire",
      "allow-trial": "Autoriser l'essai",
      "interval": "Intervalle",
      "interval-is-required": "L'intervalle est requis !",
      "price-is-required": "Le prix est requis !",
      "minimum-price-is-0": "Le prix minimum est 0 !",
      "discounted-from": "Réduit depuis",
      "description": "Description",
      "description-is-required": "La description est requise !",
      "selling-points": "Arguments de vente",
      "selling-point-x": "Argument de vente {{ x }}",
      "selling-point-is-required": "L'argument de vente est requis !",
      "analytic-is-required": "L'analytique est requise !",
      "support": "Support",
      "support-is-required": "Le support est requis !",
      "status-is-required": "Le statut est requis !",
      "manage-preset-dimensions": "Gérez les dimensions prédéfinies, leurs synonymes de détection et leurs traductions.",
      "detection-synonyms": "Synonymes de détection",
      "add-synonym-placeholder": "Saisissez un synonyme et appuyez sur Entrée",
      "translations": "Traductions",
      "missing-translation": "Traduction manquante",
      "new-dimension": "Nouvelle dimension",
      "edit-dimension": "Modifier la dimension",
      "delete-preset-dimension": "Supprimer la dimension prédéfinie",
      "do-you-want-to-delete-this-preset-dimension": "Voulez-vous supprimer « {{ name }} » ?",
      "preset-dimensions-are-shared-by-every-store": "Les dimensions prédéfinies sont partagées par toutes les boutiques — en supprimer une la retire de toutes les catégories qui l'utilisent. Cette action est irréversible.",
      "successfully-created-dimension": "Dimension créée avec succès !",
      "successfully-updated-dimension": "Dimension mise à jour avec succès !",
      "successfully-deleted-dimension": "Dimension supprimée avec succès !",
      "ai-provider-for-file-imports": "Fournisseur d'IA pour les importations de fichiers",
      "no-api-key-configured-in-this-environment": "Aucune clé d'API configurée dans cet environnement",
      "ai-provider-saved-applies-to-new-imports": "Fournisseur d'IA enregistré. Il s'applique aux nouvelles importations ; celles déjà en cours conservent leur fournisseur.",
      "ai-provider-for-size-recommendations": "Fournisseur d'IA pour les recommandations de taille",
      "ai-provider-saved-applies-to-next-recommendation": "Fournisseur d'IA enregistré. Il s'applique dès la prochaine recommandation de taille.",
      "size-recommendation-provider-hint": "Utilisé pour les recommandations de taille IA des clients. Indépendant des importations de fichiers.",
      "ai-measurement-import": "Import des mesures par IA",
      "name-admin-only": "Nom (admin uniquement)",
      "name-admin-only-hint": "L'application reconnaît les forfaits Free et Enterprise grâce à ce nom : ne les renommez pas.",
      "display-name": "Nom affiché",
      "display-name-hint": "Affiché aux marchands sur la page des forfaits, les pages de facturation et le prélèvement Shopify. Laissez vide pour utiliser le nom.",
      "display-name-too-long": "Le nom affiché ne peut pas dépasser 40 caractères !",
      "availability": "Disponibilité",
      "available-from-utc": "Disponible à partir du (UTC)",
      "available-from-hint": "Laissez vide pour le proposer dès qu'il est actif.",
      "expires-at-utc": "Expire le (UTC)",
      "expires-at-required": "Indiquez quand il expire !",
      "window-order": "Il doit devenir disponible avant d'expirer !",
      "your-time": "Votre heure : {{time}}",
      "availability-always": "Toujours proposé",
      "availability-scheduled": "Programmé : pas encore proposé",
      "availability-live": "En cours : proposé maintenant",
      "availability-ended": "Terminé : n'est plus proposé",
      "promo-plan": "Forfait promotionnel",
      "replaces-plan": "Remplace",
      "replaces-plan-none": "Rien (un forfait standard)",
      "replaces-plan-hint": "Tant que ce forfait est proposé, les marchands le voient à la place du forfait qu'il remplace.",
      "campaign": "Campagne",
      "campaign-required": "Choisissez la campagne de ce forfait promotionnel !",
      "merchants-see": "Les marchands voient",
      "replaces-x": "remplace {{x}}",
      "archiving-hint": "L'archivage masque un forfait uniquement aux nouveaux abonnés. Les abonnés actuels le conservent.",
      "duplicate-as-promo-plan": "Dupliquer en forfait promotionnel",
      "help-articles": {
        "topic": "Sujet",
        "all-topics": "Tous les sujets",
        "topics": {
          "getting-started": "Premiers pas",
          "size-charts": "Tableaux de tailles",
          "table-charts": "Tableaux de données",
          "assigning-products": "Attribution aux produits",
          "storefront-display": "Affichage en boutique",
          "chart-import": "Importation de tableaux",
          "size-recommendations": "Recommandations de taille",
          "plans-billing": "Plans et facturation",
          "troubleshooting": "Dépannage"
        },
        "new-article": "Nouvel article d'aide",
        "slug": "Slug",
        "slug-hint": "L'adresse de l'article dans le centre d'aide : /help/votre-slug. Le modifier casse les liens vers l'ancienne adresse.",
        "slug-invalid": "Utilisez des lettres minuscules, des chiffres et des tirets simples.",
        "slug-taken": "Un autre article utilise déjà ce slug.",
        "title-is-required": "Le titre est obligatoire",
        "summary": "Résumé",
        "summary-hint": "Une ligne. L'assistant de support choisit les articles d'après leur résumé.",
        "summary-is-required": "Le résumé est obligatoire",
        "order": "Ordre",
        "body-hint": "Markdown. Liez un autre article avec [texte](/help/son-slug).",
        "insert-image": "Insérer une image",
        "image-upload-failed": "Impossible de téléverser l'image.",
        "view-on-help-centre": "Voir dans le centre d'aide",
        "broken-links": "Publié, mais ces liens mènent à des articles qui n'existent pas ou ne sont pas publiés :",
        "article-saved": "Article enregistré",
        "article-published": "Article publié",
        "article-unpublished": "Article dépublié",
        "article-deleted": "Article supprimé",
        "delete-article": "Supprimer l'article",
        "delete-article-prompt": "Supprimer « {{title}} » ? Il disparaît aussitôt du centre d'aide et de l'assistant de support.",
        "load-failed": "Impossible de charger l'article.",
        "export": "Exporter",
        "import": "Importer",
        "export-failed": "Impossible d'exporter les articles.",
        "import-title": "Importer des articles d'aide",
        "import-checking": "Vérification du fichier…",
        "import-preview": "{{file}} va créer {{created}} et mettre à jour {{updated}} articles, avec {{images}} images. Les articles absents du fichier restent inchangés.",
        "import-invalid": "Ce fichier ne peut pas être importé :",
        "imported": "Importé : {{created}} créés, {{updated}} mis à jour."
      },
      "invite-only": "Sur invitation",
      "invite-only-hint": "Masqué sur la page des forfaits. Toute personne disposant du lien peut s'abonner. Ce réglage ne peut plus être modifié après la création.",
      "invite-only-price-required": "Un forfait sur invitation doit avoir un prix supérieur à 0",
      "copy-invite-link": "Copier le lien d'invitation",
      "invite-link-copied": "Lien d'invitation copié",
      "invite-link-copy-failed": "Impossible de copier le lien d'invitation"
    }
  },
  "search": {
    "no-result-found": "Aucun résultat trouvé!",
    "type": {
      "product": "Produit",
      "variant": "Variante",
      "client": "Client"
    },
    "show-less": "Réduire",
    "show-full": "Afficher tout",
    "search-x-by-full-name": "Chercher {{ x }} par nom complet",
    "load-more...": "Charger plus..."
  },
  "privacy-policy": "Politique de confidentialité",
  "contact-us": "Contactez-nous",
  "notification": {
    "notification": "Notification",
    "mark-all-as-read": "Marquer tout comme lu",
    "compose": "Composer une notification",
    "title-required": "Le titre est requis !",
    "message-required": "Le message est requis !",
    "sent-to-all-clients": "Une notification a été envoyée à tous les clients"
  },
  "table": {
    "sort": "Trier",
    "sort-by": "Trier par",
    "oldest-first": "Du plus ancien au plus récent",
    "newest-first": "Du plus récent au plus ancien",
    "a-z": "De A à Z",
    "z-a": "De Z à A",
    "lowest-first": "Du plus faible au plus élevé",
    "highest-first": "Du plus élevé au plus faible",
    "no-data-found": "Aucune donnée trouvée"
  },
  "grading": {
    "grading-configuration": "Configuration de la gradation",
    "base-size": "Taille de base",
    "enter-your-grading-allowances": "Saisissez vos permettances de gradation",
    "base": "Base"
  },
  "chart": {
    "image-nav-previous": "Image précédente",
    "image-nav-next": "Image suivante",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Ajouter une autre image",
    "image-add-slot-formats": "Accepte .png, .jpeg, .jpg",
    "image-cap-reached": "Vous avez atteint le nombre maximum d'images pour cette catégorie.",
    "image-upload-failed": "L'image n'a pas pu être téléchargée. Veuillez réessayer.",
    "image-svg-not-accepted": "Les fichiers SVG ne sont pas acceptés ici.",
    "image-delete": "Supprimer l'image",
    "image-move-left": "Déplacer l'image vers la gauche",
    "image-move-right": "Déplacer l'image vers la droite",
    "image-delete-confirm-title": "Supprimer cette image ?",
    "image-delete-confirm-body": "Cette image sera supprimée définitivement et ne pourra pas être récupérée.",
    "image-delete-confirm-cancel": "Annuler",
    "image-delete-confirm-action": "Supprimer l'image",
    "image-delete-last-tooltip": "Une catégorie doit conserver au moins une image.",
    "image-customize-first-tooltip": "Personnalisez d'abord cette catégorie pour gérer ses images.",
    "image-delete-failed": "L'image n'a pas pu être supprimée. Veuillez réessayer.",
    "image-reorder-failed": "Les images n'ont pas pu être réorganisées. Veuillez réessayer.",
    "do-you-want-to-delete-this-chart": "Voulez-vous supprimer ce tableau?",
    "unnamed-chart": "Tableau sans nom",
    "get-size-chart-permalink": "Obtenir le lien permanent du tableau de tailles",
    "chart-external-link-is-copied-to-clipboard": "Le lien externe du tableau est copié dans le presse-papier",
    "failed-to-duplicate-chart": "Échec de la duplication du tableau",
    "failed-to-create-chart": "Échec de la création du tableau",
    "add-new-layout-blocks": "Ajouter de nouveaux blocs de mise en page",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Cliquez sur ces types de blocs et ajoutez-les au tableau de tailles",
    "rename-chart": "Renommer le tableau",
    "chart-renamed-successfully": "Le tableau a été renommé avec succès.",
    "failed-to-rename-chart": "Échec du renommage du tableau",
    "preview": "Aperçu",
    "model-info": "Infos du modèle",
    "model-details": "Détails du modèle",
    "help-shoppers-by-showing-the-model-height-and-size": "Aidez les clients en montrant la taille et la hauteur du modèle",
    "model-name": "Nom du modèle",
    "enter-model-name": "Saisissez le nom du modèle",
    "model-height": "Hauteur du modèle",
    "please-enter-valid-number": "Veuillez entrer un nombre valide",
    "size-worn": "Taille portée",
    "show-variants-by": "Afficher les variantes par",
    "add-options-like-size-or-color": "Ajouter des options telles que la taille ou la couleur",
    "select-existing-chart": "Sélectionnez un tableau existant",
    "search-charts": "Rechercher des tableaux par nom",
    "no-charts-found": "Aucun tableau trouvé",
    "search-dimensions": "Rechercher des dimensions",
    "no-dimensions-found": "Aucune dimension trouvée",
    "add-a-new-size-chart": "Ajouter un nouveau tableau de tailles",
    "this-product-is-using-table-chart": "Ce produit utilise un tableau de tailles",
    "update-your-size-chart": "Mettre à jour votre tableau de tailles",
    "create-your-size-chart": "Créer votre tableau de tailles",
    "use-a-template": "Utiliser un modèle",
    "use-template-variants": "Utiliser un modèle et les variantes",
    "pick-a-method-to-get-started": "Choisir une méthode pour commencer",
    "select-an-existing-chart": "Sélectionner un tableau existant",
    "image-set-annotation-panel": "Panneau d'annotations de l'ensemble d'images",
    "measure-guide": "Guide de mesure...",
    "drag-drop-to-mark-measurement-bubble": "Glissez-déposez pour marquer la boule de mesure",
    "are-you-sure-you-want-to-delete-all-measurements": "Êtes-vous sûr de vouloir supprimer toutes les mesures?",
    "accepts-png-jpeg-jpg-svg": "Accepte .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Ce nom apparaîtra dans",
    "image-set": "l'ensemble d'images",
    "added-measurements": "Mesures ajoutées",
    "no-measurements-added-yet": "Aucune mesure n'a été ajoutée",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Glissez-déposez un bouton pour modifier sa ligne sur la toile",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Après avoir ajouté une mesure, glissez-déposez-la depuis la section « Mesures ajoutées » ci-dessus sur l'image",
    "across-shoulder-front-rise-belt": "Du côté du décolleté, Décolleté avant, Ceinture, ...",
    "create-measurement": "Créez une mesure",
    "examples-across-shoulder-front-rise-cuff-width": "Exemples : 'Du côté du décoleté', 'Décolleté avant', 'Largeur de la garde'",
    "delete-anotation-set": "Supprimez l'ensemble d'annotations",
    "this-will-remove-all-measurements-from-this-image": "Cela supprimera toutes les mesures de cette image",
    "measurement-name": "Nom de la mesure",
    "size-recommender": "Recommandateur de tailles",
    "size-recommender-history": "Recommandations récentes",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "Votre assistant personnel pour le client qui suggère instantanément la taille parfaite à chaque fois",
    "stretch-factor": "Facteur d'étirement",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Combien est étirable le tissu ? Une estimation approximative suffit. Si vous n'êtes pas sûr, laisser à 10%",
    "easing": "Étalage",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "L'étalage est la quantité ajoutée aux mesures corporelles d'une personne afin qu'elle puisse se déplacer en vêtement",
    "set-default": "Définir comme valeur par défaut",
    "suggested": "Suggéré",
    "assign-chart": "Affecter le tableau",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Votre tableau n'a pas été affecté à aucun produit encore",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Affectez votre tableau afin qu'il apparaisse sur les pages de produits",
    "assign-it-to-a-product": "L'affecter à un produit",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Sélectionner les produits ou collections où vous souhaitez que votre tableau de tailles apparaisse",
    "x-matched-y": "{{ x }} correspondent à {{ y }}",
    "overwritting-x-products": "(en écrasant {{ x }} produits)",
    "calculating...": "Calcul en cours...",
    "select-product-or-collection": "Sélectionner un produit ou une collection",
    "remove-all": "Tout supprimer",
    "are-you-sure-you-want-to-remove-all-conditions": "Êtes-vous sûr de vouloir supprimer toutes les conditions?",
    "list-of-matched-products": "Liste des produits correspondants",
    "give-your-size-chart-a-name": "Donnez un nom à votre tableau de tailles",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Ce nom est utilisé uniquement à des fins internes pour vous aider à organiser vos tableaux de tailles. Les clients ne le verront pas.",
    "eg-mens-t-shirt-size-chart": "ex. Tableau de tailles pour T-shirt homme",
    "add-text-block": "Ajouter un bloc de texte",
    "product-image-optional": "Image du produit (optionnel)",
    "add-layout-block": "Ajouter un bloc de mise en page",
    "move-this-block-up": "Monter ce bloc",
    "move-this-block-down": "Descendre ce bloc",
    "clear-this-image": "Effacer cette image",
    "align-this-image": "Aligner cette image",
    "clear-this-video": "Effacer cette vidéo",
    "apply-grading-to-this-table": "Appliquer l'ajustement à ce tableau",
    "duplicate-this-block-to-below": "Dupliquer ce bloc en dessous",
    "remove-this-block": "Supprimer ce bloc",
    "upload-an-image": "Téléverser une image",
    "browse-to-upload": "Parcourir pour téléverser",
    "choose-from-our": "Choisir parmi nos",
    "ready-made-templates": "modèles prêts à l'emploi",
    "select-a-template": "Sélectionner un modèle",
    "new-row": "Nouvelle ligne",
    "new-column": "Nouvelle colonne",
    "add-column-left": "Ajouter une colonne à gauche",
    "add-column-right": "Ajouter une colonne à droite",
    "move-left": "Déplacer vers la gauche",
    "move-right": "Déplacer vers la droite",
    "freeze": "Geler",
    "unfreeze": "Dégeler",
    "delete-column": "Supprimer la colonne",
    "add-row-above": "Ajouter une ligne au-dessus",
    "add-row-below": "Ajouter une ligne en dessous",
    "move-up": "Déplacer vers le haut",
    "move-down": "Déplacer vers le bas",
    "delete-row": "Supprimer la ligne",
    "insert-video": "Insérer une vidéo",
    "select-a-video": "Sélectionner une vidéo",
    "paste-a-link-to-a-video-here": "Coller un lien vers une vidéo ici",
    "webgl-not-supported": "Votre navigateur ne prend pas en charge WebGL. Veuillez activer la prise en charge de WebGL si vous utilisez un navigateur moderne tel que Chrome, Firefox ou Safari.",
    "table-chart-created": "Tableau de données créé",
    "name-this-image-set": "Donnez un nom à cet ensemble d'images",
    "name-your-import": "Donnez un nom à votre importation",
    "table-chart-updated": "Charte en tableau mise à jour!",
    "chart-updated": "Tableau mis à jour",
    "use-how-to-measure-block": "Utiliser un bloc de texte pour la mesure? (Optionnel)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Un bloc de texte sous un panneau développable sera ajouté où vous pouvez remplir les détails pour vos clients sur comment mesurer leurs mesures",
    "newest-5-recommendations-given-to-your-customers": "5 dernières recommandations données à vos clients",
    "size-recommended": "Taille recommandée",
    "view-all-data": "Voir toutes les données",
    "please-select-a-size-worn": "Veuillez sélectionner une taille portée",
    "recommended-for-this-garment-add-or-remove-as-needed": "Recommandé pour ce vêtement, ajoutez ou supprimez selon vos besoins",
    "add-more": "Ajouter plus",
    "add-custom-measurements": "Ajouter des mesures personnalisées",
    "skip-this-step-next-time": "Passer cette étape la prochaine fois",
    "use-unit-conversion": "Utiliser la conversion d'unité",
    "disabled-by-chart": "Désactivé par le tableau",
    "disabled-globally-by-settings": "Désactivé globalement par les paramètres",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Masquer le bouton de conversion d'unité sur tous les tableaux qui apparaissent sur votre boutique",
    "assign-products": "Affecter des produits",
    "select-products-to-assign-to-the-chart": "Sélectionnez les produits à affecter au tableau",
    "products-assigned-successfully": "Produits affectés avec succès",
    "source-table": "Tableau source",
    "root-table": "Tableau principal",
    "table-block": "Tableau",
    "which-axis-holds-the-dimension-data": "Quel axe contient les données de dimensions ? (Épaule, Taille, etc.)",
    "columns": "Colonnes",
    "rows": "Lignes",
    "measurement-unit": "Unité de mesure",
    "map-each-line-to-a-dimension": "Associez chaque ligne à une dimension",
    "ignore": "Ignorer",
    "line": "Ligne",
    "the-selected-table-has-no-data-to-map": "Le tableau sélectionné n'a aucune donnée à associer.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Indiquez comment votre tableau correspond aux dimensions du corps afin que nous puissions suggérer une taille.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Choisissez le tableau que l'IA lit pour suggérer une taille.",
    "per-dimension-stretch-and-easing-controls": "Contrôles d'élasticité et d'aisance par dimension",
    "jump-to-table": "Aller au tableau",
    "scroll-to-the-selected-table": "Faire défiler jusqu'au tableau sélectionné",
    "this-table-is-used-as-your-size-recommendation-data-source": "Ce tableau est utilisé comme source de données pour vos recommandations de taille",
    "this-table-block-can-not-be-deleted-right-now": "Ce bloc de tableau ne peut pas être supprimé pour le moment",
    "this-table-is-used-as-your-size-recommendation-data-source-deleting-it-will-clear-that-mapping-continue": "Ce tableau est utilisé comme source de données pour la recommandation de taille. Le supprimer effacera cette correspondance. Continuer ?"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Il y a eu une erreur lors de l'authentification de votre boutique!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Cliquez sur le bouton ci-dessous pour recommencer. Si le problème persiste, contactez-nous pour des instructions supplémentaires.",
    "refresh-the-app": "Rafraîchir l'application",
    "error-occured": "Erreur!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Ajoutez le bouton du guide des tailles Goodchart à votre boutique",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Nous avons détecté que vous intégrez avec Shopify. Activez l'intégration de l'application pour afficher automatiquement le bouton du guide des tailles sur toutes les pages produit, ou ajoutez un bloc d'application pour le placer à un endroit précis. Besoin d'aide ? Consultez ce <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">guide</a>.",
    "enable-app-embed": "Activer l'intégration de l'application",
    "add-app-block": "Ajouter un bloc d'application",
    "your-new-size-chart-is-ready-to-review": "Votre nouveau guide des tailles est prêt à être vérifié",
    "look-around-then-hand-the-conversion-over": "Rien n'a encore changé pour vos clients — votre tableau des tailles reste celui qui est actif. Prenez le temps de vérifier les mesures et le guide, puis transférez la conversion quand tout vous convient.",
    "about-your-plan-usage": "À propos de l'utilisation de votre plan",
    "measurements-applied": "Mesures appliquées",
    "selection-applied-all-variants": "La sélection a été appliquée à toutes les variantes de tailles.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Vous avez atteint {{ x }} % de la limite de recommandations de taille IA de votre formule actuelle. Veuillez noter que toute utilisation au-delà de 100 % sera facturée au tarif standard.",
    "you-have-reached-x-of-stock-notification-limit": "Vous avez atteint {{ x }} % de la limite de notifications de stock de votre formule actuelle.",
    "over-usage-cost": "Coût de dépassement d'utilisation",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Vous avez dépassé votre limite de recommandations de taille IA. Veuillez régler le coût de dépassement d'utilisation pour continuer à utiliser le service.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Vous avez dépassé votre limite de recommandations de taille IA. Veuillez régler le coût de dépassement d'utilisation pour continuer à utiliser cette fonctionnalité.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} de vos tableaux de tailles peuvent être améliorés en guides de tailles intelligents"
  },
  "onboarding": {
    "skip-for-now": "Passer pour l'instant",
    "step-x-of-y": "Étape {{ x }} de {{ y }}",
    "select-the-category-that-best-matches-your-product": "Sélectionnez la catégorie qui correspond le mieux à votre produit.",
    "apparel": "Vêtements",
    "tops": "Tops",
    "pants": "Pantalons",
    "dresses": "Robes",
    "shoes": "Chaussures",
    "sneakers": "Sneakers",
    "boots": "Bottines",
    "sandals": "Sandales",
    "accessories": "Accessoires",
    "belts": "Ceintures",
    "bags": "Sac",
    "hats": "Chapeaux",
    "other-custom": "Autres / Sur mesure",
    "equipment": "Équipement",
    "tool": "Outil",
    "furniture": "Meubles",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Téléchargez une image de produit et placez les mesures visuellement. Fonctionne pour la mode, les chaussures et les accessoires.",
    "table-style-chart": "Tableau de données",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Créez un diagramme à grille avec des lignes et des colonnes. Idéal pour les spécifications de tailles détaillées.",
    "your-size-chart-is-ready": "Votre tableau de tailles est prêt",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Vous pouvez maintenant décider où ce tableau de tailles devrait apparaître dans votre boutique. Vous pouvez passer cette étape et affecter des produits plus tard.",
    "apply-this-chart-to-products-now": "Appliquer ce tableau de tailles aux produits maintenant",
    "choose-which-products-should-use-this-size-chart": "Choisir les produits qui devraient utiliser ce tableau de tailles.",
    "i-ll-do-this-later": "Je le ferai plus tard",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Vous pouvez affecter ou modifier les correspondances à tout moment depuis les paramètres du tableau de tailles.",
    "select-products-to-assign-chart-to": "Sélectionnez les produits à assigner un tableau de tailles",
    "apply-this-chart-to-all-products": "Appliquez ce tableau de tailles à tous les produits.",
    "select-products-to-apply-this-chart-to": "Sélectionnez les produits à appliquer ce tableau de tailles.",
    "assigning...": "Assignant...",
    "size-chart-created-successfully": "Tableau de tailles créé avec succès",
    "you-can-assign-products-anytime-from-chart-settings": "Vous pouvez assigner des produits à tout moment depuis les paramètres du tableau de tailles.",
    "view-chart": "Voir le tableau de tailles",
    "go-to-dashboard": "Aller vers le tableau de bord",
    "turn-your-size-chart-into-a-conversion-tool": "Transformez votre tableau de tailles en outil de conversion",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Aidez les clients à choisir la taille correcte et réduisez les retours",
    "setup-takes-about-2-minutes": "La configuration prend environ 2 minutes.",
    "choose-how-your-size-chart-looks": "Choisissez comment votre tableau de tailles doit s'afficher",
    "other-ways-to-create-a-chart": "Autres façons de créer un tableau de tailles",
    "failed-to-proceed-please-try-again": "Échec de la procédure, veuillez réessayer",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Ce tableau est connecté à votre produit et vos variantes Shopify, afin que les clients puissent sélectionner leur taille, ajouter au panier ou acheter maintenant sans quitter le tableau",
    "add-the-size-guide-button-to-your-storefront": "Ajoutez le bouton de guide des tailles à votre boutique",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Choisissez comment le bouton de guide des tailles GoodChart doit apparaître sur vos pages produit.",
    "enable-app-embed": "Activer l'intégration de l'application",
    "installed": "Installé",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Affichez automatiquement le bouton de guide des tailles sur toutes les pages produit.",
    "add-app-block-to-product-page": "Ajouter un bloc d'application à la page produit",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Vous préférez placer le bouton à un endroit précis sur votre page produit ?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Placez le bouton de guide des tailles à un endroit précis du modèle de votre page produit.",
    "open": "Ouvrir",
    "check-button-installation": "Vérifier l'installation du bouton",
    "checking": "Vérification...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Parfait ! Le bouton de guide des tailles est installé sur votre boutique.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Nous n'avons pas encore détecté le bouton de guide des tailles. Veuillez vous assurer d'avoir enregistré les modifications dans l'éditeur de thème.",
    "app-block-installed-on-your-product-page": "Bloc d'application installé sur votre page produit"
  },
  "common": {
    "updated": "Mis à jour",
    "name": "Nom",
    "avatar": "Avatar",
    "category-image": "Image de catégorie",
    "increase": "Augmentation",
    "created": "Créé",
    "email": "Email",
    "password": "Mot de passe",
    "yes": "Oui",
    "no": "Non",
    "chart": "Tableau de tailles",
    "gender": "Genre",
    "height": "Taille",
    "weight": "Poids",
    "age-group": "Tranche d'âge",
    "fit-preference": "Préférence d'ajustement",
    "score": "Score",
    "table-chart": "Tableau de données",
    "draft": "Brouillon",
    "active": "Actif",
    "products": "Produits",
    "none": "Aucun",
    "cancel": "Annuler",
    "retry": "Réessayer",
    "delete": "Supprimer",
    "export": "Exporter",
    "variant": "Variante",
    "variants": "Variantes",
    "account": "Compte",
    "personal": "Personnel",
    "appearance": "Apparence",
    "organization": "Organisation",
    "information": "Information",
    "first-name": "Prénom",
    "last-name": "Nom",
    "save": "Sauvegarder",
    "pay": "Payer",
    "undo": "Annuler",
    "redo": "Rétablir",
    "newsletter-subscription": "S'inscrire à la newsletter",
    "button": "Bouton",
    "colour": "Couleur",
    "default": "Par défaut",
    "white": "Blanc",
    "light-grey": "Gris clair",
    "soft-beige": "Beige doux",
    "saving...": "Enregistrement en cours...",
    "all-changes-saved": "Toutes les modifications sont enregistrées",
    "publish": "Publier",
    "unpublish": "Dépublier",
    "images": "Images",
    "charts": "Tableaux de tailles",
    "confirm": "Confirmer",
    "dimensions": "Dimensions",
    "new": "Nouveau",
    "missing": "Manquant",
    "editing-x": "Éditer {{ x }}",
    "back-in-stock": "En stock à nouveau",
    "product": "Produit",
    "grading": "Gradation",
    "more-actions": "Plus d'actions",
    "table": "Tableau",
    "measurement": "Mesures",
    "close": "Fermer",
    "apply": "Appliquer",
    "duplicate": "Dupliquer",
    "add-layout-blocks": "Ajouter des blocs de mise en page",
    "text": "Texte",
    "image": "Image",
    "video": "Vidéo",
    "new-name": "Nouveau nom",
    "published": "Publié",
    "all": "Tous",
    "editing": "Éditer",
    "show-more": "Afficher plus",
    "loading": "Chargement en cours",
    "or": "Ou",
    "browse-files": "Parcourir les fichiers",
    "edit": "Éditer",
    "customize": "Personnaliser",
    "clear": "Effacer",
    "label": "Étiquette",
    "discard-changes": "Annuler les modifications",
    "uploading": "Téléchargement en cours",
    "preset": "Paramètre prédéfini",
    "custom": "Personnalisé",
    "manage": "Gérer",
    "done": "Terminé",
    "reminder": "Rappel",
    "collections": "Collections",
    "all-products": "Tous les produits",
    "select": "Sélectionner",
    "search": "Rechercher",
    "select-all": "Sélectionner tout",
    "size-chart": "Tableau de tailles",
    "continue": "Continuer",
    "back": "Retour",
    "visual-measurement-builder": "Constructeur de mesures visuelles",
    "recommend": "Recommander",
    "creating...": "Création...",
    "syncing": "Synchronisation...",
    "preview": "Aperçu",
    "create": "Créez",
    "onboarding": "Accueil",
    "english": "English",
    "french": "Français",
    "spanish": "Espagnol",
    "czech": "Tchèque",
    "danish": "Danois",
    "german": "Allemand",
    "italian": "Italien",
    "dutch": "Néerlandais",
    "japanese": "Japonais",
    "off": "Désactivé",
    "basic": "Basique",
    "AI": "AI",
    "details": "Détails",
    "date": "Date",
    "billing": "Facturation",
    "settings": "Paramètres",
    "log-out": "Déconnexion",
    "plan": "Plan",
    "ai-size-recommendation": "Recommandation de taille AI",
    "recommendations": "Recommandations",
    "features": "Fonctionnalités",
    "stock-notification": "Notification de stock",
    "published-size-charts": "Tableaux de tailles publiés",
    "published-table-charts": "Tableaux de données publiés",
    "unlimited": "Illimité",
    "x-of-y": "{{ x }} de {{ y }}",
    "measurements": "Mesures",
    "selected": "Sélectionnés",
    "select-product": "Sélectionner un produit",
    "price": "Prix",
    "title": "Titre",
    "message": "Message",
    "add": "Ajouter",
    "remove": "Supprimer",
    "cm": "cm",
    "in": "po",
    "usd": "USD",
    "return": "Retour",
    "next": "Suivant",
    "store": "Boutique",
    "type": "Type",
    "cost": "Coût",
    "incurred-at": "Encouru le",
    "search-placeholder": "Rechercher...",
    "more": "Plus...",
    "load-more": "Charger plus...",
    "status": "Statut",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "total": "Total",
    "un-listed": "Non répertorié",
    "global": "Global",
    "store-specific": "Spécifique à la boutique",
    "ai-measurement-import": "Import des mesures par IA",
    "included": "Inclus",
    "not-included": "Non inclus"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Préférences mises à jour avec succès",
    "failed-to-update-your-preferences": "Échec de la mise à jour des préférences"
  },
  "import": {
    "upload-file": "Téléverser un fichier",
    "sheet-import": {
      "title": "Importer des mesures depuis un fichier",
      "dropzone": {
        "title": "Glissez-déposez un fichier ici",
        "accepted-types": "{{types}} — un seul fichier à la fois",
        "browse": "Parcourir les fichiers"
      },
      "hint": "Pour un meilleur résultat : un seul tableau dont les tailles correspondent aux variantes de ce tableau de tailles, avec les en-têtes en première ligne ou colonne. Pour une photo ou une capture d'écran, qu'elle soit nette et prise de face, recadrée sur le tableau uniquement.",
      "example": {
        "caption": "Exemple de mise en page acceptée :",
        "size": "Taille",
        "chest": "Poitrine (cm)",
        "waist": "Taille (cm)"
      },
      "error": {
        "invalid-type": "Ce type de fichier n'est pas pris en charge. Importez l'un des formats suivants : {{types}}.",
        "heic-unsupported": "Les photos HEIC (format iPhone) ne sont pas prises en charge. Exportez la photo en JPG ou PNG et importez ce fichier.",
        "file-too-large": "Ce fichier est trop volumineux. La taille maximale est de {{maxSizeMb}} Mo."
      },
      "submit": "Importer et vérifier les modifications",
      "running": {
        "this-chart": "Une importation est déjà en cours pour ce tableau de tailles.",
        "other-chart": "Une importation est déjà en cours pour un autre tableau de tailles. Une seule importation peut s'exécuter à la fois.",
        "open-import": "Voir l'importation"
      },
      "accepted-files-tooltip": "Fichiers acceptés : {{types}}",
      "button": {
        "importing": "Importation… {{progress}} %",
        "review": "Vérifier l'importation"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Trouvez votre meilleure taille",
      "subtitle": "Quelques détails rapides pour un meilleur ajustement",
      "shopping-for": "VOUS ACHETEZ POUR",
      "women": "Femme",
      "men": "Homme",
      "other": "Autre",
      "measurements": "MESURES",
      "height": "Taille",
      "height-required": "La taille est requise",
      "min-height": "La taille minimale est 1",
      "weight": "Poids",
      "weight-required": "Le poids est requis",
      "min-weight": "Le poids minimal est 1",
      "preferred-fit": "Coupe préférée"
    },
    "result": {
      "suggested-size": "Taille suggérée :",
      "no-fit": "Malheureusement, il semble que nous n'ayons pas de taille idéale pour le moment. Nous vous recommandons de revenir plus tard pour plus d'options.",
      "verdict": "Verdict :",
      "similar-variants": "Variantes similaires :",
      "proceed": "Continuer avec cette variante",
      "estimate-disclaimer": "(Estimation basée sur la marque et les informations utilisateur, les résultats peuvent varier.)"
    },
    "ai": {
      "upgrade-title": "Améliorez votre forfait pour débloquer la recommandation de taille AI",
      "upgrade-description": "Une fonctionnalité qui aide vos clients à trouver la bonne taille à chaque fois. Notre IA analyse les détails du produit et les informations des clients pour fournir des suggestions de taille personnalisées, afin que les acheteurs achètent en toute confiance et que vous constatiez moins de retours et d'échanges. Améliorez votre forfait maintenant pour offrir cette expérience sur votre boutique.",
      "image-alt": "Recommandation de taille",
      "upgrade-enable": "Améliorer et activer maintenant",
      "explore-plans": "Explorer d'autres forfaits",
      "failed-load-recommendations": "Échec du chargement des recommandations",
      "failed-fetch-plans": "Échec de la récupération des forfaits",
      "form-tab": "Formulaire",
      "result-tab": "Résultat"
    },
    "basic": {
      "measurements-required-title": "Ajoutez d'abord des mesures",
      "measurements-required-description": "La recommandation de taille basique attribue une taille aux acheteurs à partir des mesures de ce tableau. Ajoutez des mesures au tableau, puis activez-la."
    }
  },
  "chart-limit": {
    "title-size": "Vous avez atteint votre limite de tableaux de tailles publiés",
    "title-table": "Vous avez atteint votre limite de tableaux de données publiés",
    "description-size": "Votre forfait vous permet de publier {{limit}} tableaux de tailles, et vous en avez {{usage}} publiés. Ce tableau a été conservé en brouillon. Améliorez votre forfait pour en publier davantage, ou dépubliez un tableau dont vous n'avez plus besoin.",
    "description-table": "Votre forfait vous permet de publier {{limit}} tableaux de données, et vous en avez {{usage}} publiés. Ce tableau a été conservé en brouillon. Améliorez votre forfait pour en publier davantage, ou dépubliez un tableau dont vous n'avez plus besoin.",
    "upgrade-plan": "Améliorer le forfait",
    "explore-plans": "Explorer les forfaits",
    "failed-fetch-plans": "Impossible de charger les forfaits. Veuillez réessayer.",
    "image-alt": "Illustration de tableau",
    "onboarding-saved-as-draft": "Votre tableau a été enregistré en brouillon, car la limite de tableaux publiés de votre forfait est atteinte. Vous pourrez le publier après avoir amélioré votre forfait ou dépublié un autre tableau."
  },
  "help-centre": "Centre d'aide",
  "dimension-inputs": {
    "add-measurement": "Ajouter une mesure"
  },
  "variant-editor": {
    "option-name": "Nom de l'option",
    "option-values": "Valeurs de l'option",
    "option-placeholder": "Taille / Couleur / Tissu",
    "add-option": "Ajouter une autre option"
  },
  "dimension": {
    "shoulder": "Épaule",
    "bust": "Poitrine",
    "waist": "Taille",
    "arm": "Bras",
    "sleeve": "Manche",
    "hip": "Hanche",
    "crotch": "Entrejambe",
    "leg": "Jambe",
    "thigh": "Cuisse",
    "length": "Longueur",
    "bottom_width": "Largeur du bas",
    "chest": "Tour de poitrine",
    "inside_leg": "Longueur intérieure de jambe",
    "back_length": "Longueur dos",
    "front_length": "Longueur devant",
    "front_rise": "Hauteur devant",
    "back_rise": "Hauteur dos",
    "leg_opening": "Ouverture de jambe",
    "overbust": "Au-dessus de la poitrine",
    "underbust": "Sous la poitrine",
    "groups": {
      "tops": "Hauts",
      "bottoms": "Bas",
      "generals": "Généraux"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 mois",
      "3m": "3 mois",
      "6m": "6 mois",
      "1y": "1 an"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Une restauration est déjà en cours pour cette boutique. Attendez qu’elle se termine et réessayez.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Une sauvegarde est créée uniquement les jours où vous modifiez quelque chose.",
    "actor": {
      "merchant": "vous",
      "support": "Assistance Goodchart",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Votre facturation, votre forfait, votre connexion et vos intégrations ne sont pas affectés.",
    "blocked": {
      "entity-exists": "Déjà recréé — restaurer à la place",
      "entity-missing": "N’existe plus — restaurer à la place",
      "unsupported": "Impossible à annuler — restaurer à la place",
      "value-changed": "Modifié depuis — restaurer à la place"
    },
    "changes": "Modifications",
    "discard-unsaved-changes": "Abandonner les modifications non enregistrées ?",
    "dont-ask-again-in-this-session": "Ne plus demander pendant cette session",
    "earlier": "Plus tôt",
    "history": "Historique",
    "history-starts-from-your-first-snapshot": "L’historique démarre à votre première sauvegarde",
    "label": {
      "category-created": "Catégorie {{name}} créée",
      "category-deleted": "Catégorie {{name}} supprimée",
      "category-updated": "Catégorie {{name}} modifiée",
      "chart-created": "Guide {{name}} créé",
      "chart-deleted": "Guide {{name}} supprimé",
      "chart-updated": "Guide {{name}} modifié",
      "dimension-created": "Mesure {{name}} créée",
      "dimension-deleted": "Mesure {{name}} supprimée",
      "dimension-updated": "Mesure {{name}} modifiée",
      "draft-assignment-rules": "Règles d'attribution modifiées",
      "draft-edited": "Tableau modifié",
      "draft-guide": "Guide de mesure modifié",
      "draft-labels": "Étiquettes de taille modifiées",
      "draft-measurements": "Mesures modifiées",
      "draft-model": "Mensurations du mannequin modifiées",
      "draft-publication": "Publication modifiée",
      "draft-renamed": "Tableau renommé",
      "draft-size-recommender": "Recommandation de taille modifiée",
      "draft-variants": "Variantes modifiées",
      "keyword-created": "Mot-clé {{name}} créé",
      "keyword-deleted": "Mot-clé {{name}} supprimé",
      "keyword-updated": "{{count}} mots-clés modifiés",
      "products-assigned": "{{count}} produits associés",
      "profile-updated": "Profil de la boutique mis à jour",
      "store-restored": "Boutique restaurée au {{date}}",
      "table-chart-created": "Tableau {{name}} créé",
      "table-chart-deleted": "Tableau {{name}} supprimé",
      "table-chart-updated": "Tableau {{name}} modifié"
    },
    "no-changes-since-then": "Aucune modification depuis.",
    "no-snapshots-yet": "Aucune sauvegarde pour le moment",
    "nothing-created-since-then-will-be-deleted": "Rien de ce qui a été créé depuis ne sera supprimé.",
    "plus-x-more": "+{{x}} autres",
    "reloading-the-dashboard": "Rechargement du tableau de bord…",
    "restore": "Restaurer",
    "restore-confirmation-word": "RESTAURER",
    "restore-instead": "Restaurer à la place",
    "restore-your-store": "Restaurer votre boutique",
    "restoring-your-store-do-not-close-this-window": "Restauration de votre boutique. Ne fermez pas cette fenêtre.",
    "since-the-x-snapshot": "Depuis la sauvegarde du {{x}}",
    "snapshots": "Sauvegardes",
    "the-change-was-undone-but-the-page-could-not-refresh": "La modification a été annulée, mais cette page n’a pas pu être actualisée. Rechargez pour la voir.",
    "this-backup-predates-image-protection": "Cette sauvegarde est antérieure à la protection des images : toute image supprimée depuis est irrécupérable.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Cela modifie en quelques secondes ce que voient les clients sur vos pages produits.",
    "this-changes-what-shoppers-see-right-away": "Cela modifie immédiatement ce que voient les clients.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Votre boutique reviendra à son état du {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Cela annule {{x}} actions, jusqu’à « {{y}} » incluse.",
    "trigger": {
      "daily": "Quotidienne",
      "install": "À l’installation de Goodchart",
      "manual": "Manuelle (assistance)",
      "migration": "Première sauvegarde",
      "pre-restore": "Avant restauration",
      "reinstall": "À la réinstallation de Goodchart"
    },
    "type-x-to-confirm": "Saisissez {{x}} pour confirmer",
    "undid-x": "« {{x}} » annulé",
    "undo-a-saved-change": "Annuler une modification enregistrée",
    "undo-to-here": "Annuler jusqu’ici",
    "undo-x-saved-y": "Annuler « {{x}} », enregistrée {{y}} ?",
    "unsaved": "Non enregistré",
    "we-could-not-load-your-history": "Impossible de charger votre historique.",
    "we-could-not-load-your-snapshots": "Impossible de charger vos sauvegardes.",
    "we-could-not-restore-your-store": "Impossible de restaurer votre boutique.",
    "we-could-not-work-out-what-would-change": "Impossible de déterminer ce qui changerait.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Nous sauvegardons d’abord votre boutique actuelle, afin que cette opération puisse être annulée.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Nous sauvegardons votre boutique chaque jour où elle change. Votre historique apparaîtra ici dès la première sauvegarde.",
    "what-comes-back": "Ce qui revient",
    "what-is-lost": "Ce qui est perdu",
    "working-out-what-would-change": "Analyse de ce qui changerait…",
    "x-assignments": "{{x}} associations",
    "x-charts": "{{x}} guides",
    "x-images-cannot-be-brought-back": "{{x}} images ne peuvent pas être récupérées — elles ont été supprimées il y a plus de 37 jours.",
    "x-images-could-not-be-recovered": "{{x}} images n’ont pas pu être récupérées — elles ont été supprimées il y a plus de 37 jours.",
    "x-items-created-since-then-will-be-deleted": "{{x}} éléments créés depuis seront supprimés, dont :",
    "x-items-will-be-recreated": "{{x}} éléments seront recréés.",
    "x-no-longer-exists-after-the-undo": "« {{x}} » n’existe plus après l’annulation.",
    "x-table-charts": "{{x}} tableaux",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Vous avez des modifications non enregistrées sur « {{x}} ». L’annulation les abandonnera.",
    "your-store-has-been-restored": "Votre boutique a été restaurée."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Lecture de votre fichier",
        "understanding-table": "Analyse du tableau",
        "matching-measurements": "Association des mesures",
        "building-chart": "Création de votre tableau"
      },
      "reconnecting": "Reconnexion — pas d'inquiétude, votre progression n'est pas perdue.",
      "keep-working": "Vous pouvez continuer à travailler — nous vous préviendrons dès que ce sera prêt.",
      "cancel": "Annuler l'importation",
      "cancel-confirm": {
        "title": "Annuler cette importation ?",
        "message": "Votre fichier importé sera abandonné et cette importation ne pourra pas être reprise.",
        "keep": "Continuer à attendre",
        "discard": "Annuler l'importation"
      },
      "ready": {
        "title": "Tableau prêt à être révisé",
        "action": "Vérifier les modifications"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "Cette photo était trop floue ou trop sombre pour être lue. Une photo plus nette et bien éclairée fonctionne mieux."
      },
      "no-table-found": {
        "message": "Nous n'avons pas trouvé de tableau de tailles dans ce fichier."
      },
      "unsupported-layout": {
        "message": "La mise en page de ce tableau n'est pas encore prise en charge."
      },
      "model-timeout": {
        "message": "Cela a pris trop de temps — il s'agit généralement d'un problème temporaire."
      },
      "internal": {
        "message": "Une erreur est survenue de notre côté lors de l'importation de votre tableau."
      },
      "action": {
        "retry": "Réessayer",
        "try-another-photo": "Essayer une autre photo",
        "try-another-file": "Essayer un autre fichier",
        "other-methods": "Autres méthodes"
      }
    },
    "diff-review": {
      "title": "Vérifiez les modifications",
      "subtitle": "Décochez ce que vous ne souhaitez pas appliquer à ce tableau.",
      "load-error": "Impossible de charger les modifications de cette importation.",
      "no-changes": "Aucune mesure n'a changé.",
      "grid": {
        "variant": "Taille",
        "dimension": "Mesure",
        "old-value": "Actuel",
        "new-value": "Nouveau"
      },
      "unmatched-variants": "Tailles du fichier qui ne correspondent à aucune taille de ce tableau :",
      "unmapped-dimensions": "Colonnes que nous n'avons pas pu associer à une mesure :",
      "apply": {
        "button": "Appliquer les modifications ({{count}})",
        "success": "Tableau mis à jour ({{count}} modifications appliquées)",
        "generic-error": "Impossible d'appliquer ces modifications. Veuillez réessayer."
      },
      "cancel": {
        "button": "Annuler l'importation"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Annuler cette importation ?",
        "message": "Votre fichier importé et vos modifications seront abandonnés. Cette importation ne pourra pas être reprise.",
        "keep": "Continuer la vérification",
        "discard": "Annuler l'importation"
      }
    },
    "page": {
      "title": "Importer des mesures",
      "empty": {
        "title": "Aucune importation n'est en cours pour ce tableau de tailles",
        "message": "Téléversez une feuille de calcul ou une photo d'un tableau de tailles pour mettre à jour les mesures de ce tableau."
      }
    },
    "upgrade": {
      "title": "Importez vos mesures avec l'IA",
      "description": "Importez un tableur ou une photo d'un tableau de tailles et nous remplirons les mesures de ce tableau pour vous. L'import des mesures par IA n'est pas inclus dans votre forfait actuel. Améliorez votre forfait pour l'utiliser.",
      "upgrade-plan": "Améliorer le forfait",
      "explore-plans": "Explorer les forfaits",
      "failed-fetch-plans": "Impossible de charger les forfaits. Veuillez réessayer.",
      "image-alt": "Illustration d'un tableau de tailles"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Prix Black Friday",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Jusqu'à -{{percent}} %",
        "subheadline": "sur les forfaits Goodchart",
        "body": "Préparez vos guides des tailles pour la semaine la plus chargée de l'année. Des tailles claires, c'est moins de questions « ça va m'aller ? » et moins de retours.",
        "feature-recommender": "Recommandation de taille par IA qui suggère sa taille à chaque client",
        "feature-import": "Import par IA qui transforme un fichier ou une image en guide des tailles",
        "feature-analytics": "Analyses de l'utilisation de vos guides des tailles par les clients",
        "cta": "Voir les offres",
        "later": "Plus tard"
      },
      "show-offer": "Voir l'offre Black Friday"
    },
    "every-plan": "-{{percent}} % sur tous les forfaits",
    "up-to": "Jusqu'à -{{percent}} %",
    "switch-to": "Passer à {{price}} $/{{interval}}",
    "switch-from": "Vous avez {{name}} à {{price}} $/{{interval}}. Mêmes fonctionnalités, {{percent}} % moins cher.",
    "switch-note-monthly": "Shopify vous demande d'approuver le nouveau prix et vous crédite le reste du mois.",
    "switch-note-annual": "Shopify vous demande d'approuver le nouveau prix, qui s'applique à votre renouvellement le {{date}}.",
    "switch-note-annual-undated": "Shopify vous demande d'approuver le nouveau prix, qui s'applique à votre prochain renouvellement."
  },
  "agent-chat": {
    "open": "Ouvrir le chat d’assistance",
    "close": "Fermer le chat d’assistance",
    "expand": "Agrandir le chat",
    "collapse": "Réduire le chat",
    "title": "Assistance Goodchart",
    "history": "Conversations",
    "back": "Retour à la conversation",
    "new": "Nouvelle conversation",
    "placeholder": "Posez une question sur Goodchart",
    "send": "Envoyer",
    "welcome": "Bonjour ! Posez-moi vos questions sur Goodchart : créer des tableaux de tailles, le guide des tailles sur votre boutique ou votre forfait.",
    "history-empty": "Aucune conversation pour l’instant.",
    "unread": "Nouvelle réponse",
    "you": "Vous",
    "merchant": "Marchand",
    "assistant": "Assistant Goodchart",
    "team": "Équipe Goodchart",
    "typing": "Rédaction…",
    "used-articles": "Réponse tirée des articles d’aide",
    "retry": "Réessayer",
    "activity": {
      "articles": "Lecture des articles d’aide…",
      "store": "Consultation de votre boutique…",
      "code": "Vérification du fonctionnement de Goodchart…",
      "team": "Transmission à l’équipe Goodchart…"
    },
    "error": {
      "rate-limited": "Vous envoyez des messages trop vite. Réessayez dans {{seconds}} secondes. Si vous avez besoin de l’équipe Goodchart, demandez-la-moi dès que vous pourrez écrire à nouveau.",
      "daily-cap": "Vous avez atteint la limite de messages du jour. Réessayez demain et demandez-moi alors l’équipe Goodchart si vous en avez toujours besoin.",
      "disabled": "L’assistant d’assistance est indisponible pour le moment.",
      "reply-failed": "La réponse n’est pas arrivée.",
      "unknown": "Une erreur est survenue."
    },
    "placeholder-team": "Ajoutez des précisions pour l’équipe Goodchart",
    "unavailable": "L’assistant d’assistance est indisponible pour le moment et ne prend pas de nouvelles questions. Les conversations déjà prises en charge par l’équipe Goodchart restent ouvertes dans votre historique.",
    "waiting": {
      "title": "En attente de l’équipe Goodchart.",
      "body": "Elle répondra ici et vous recevrez une notification. Vous pouvez ajouter des précisions en attendant."
    },
    "starters": {
      "create-chart": "Comment créer un tableau de tailles ?",
      "no-chart": "Quels produits n’ont pas de tableau de tailles ?",
      "not-showing": "Pourquoi mon tableau de tailles ne s’affiche-t-il pas sur ma boutique ?",
      "charts-left": "Combien de tableaux puis-je encore publier ?"
    },
    "feedback": {
      "helpful": "Utile",
      "not-helpful": "Pas utile",
      "thanks": "Merci pour votre retour.",
      "comment-placeholder": "Qu’est-ce qui n’allait pas ou manquait ? (facultatif)",
      "send": "Envoyer",
      "skip": "Passer",
      "rated-up": "Jugé utile",
      "rated-down": "Jugé pas utile"
    }
  }
}
